; (function ($) {

    'use strict';

    var validate = function (options, callback) {
        var fields = options.fields || [];
        var submit = options.submit || false;
        var files = options.files || false;
        var $form = $(this);
        var $fields = fields ? $(fields) : $form.find('input, select, textarea');
        var $submits = $form.find("[type=submit], [data-validate=true]").prop("disabled", true);
        var formData = new FormData($form[0]);
        var regexEscape = function (s) {
            return s.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
        };
        if (!files) {
            $form.find('input[type=file]').each(function () {
                formData.delete($(this).attr('name'));
            });
        }
        formData.append('method', 'validate');
        $fields.each(function () {
            formData.append('validate[]', $(this).attr('name'));
        });
        $.each(options.data || [], function (key, value) {
            formData.append(key, value);
        });
        var opts = {
            url: $form.attr('action') || document.location,
            method: new String($form.attr('method')).toUpperCase() || 'GET',
            data: formData,
            contentType: false,
            processData: false,
            success: function (response) {
                $fields.parents('.form-group').first().removeClass('has-error');
                $fields.removeClass('has-error');
                if (response.options) {
                    $.each(response.options, function (field, options) {
                        var $control = $form.find('select[name=' + regexEscape(field) + ']');
                        $control.empty();
                        $.each(options, function (index, option) {
                            $control.append(
                                $('<option>').text(option.label).val(option.value).prop('selected', index == 0)
                            );
                        });
                    });
                }
                if (response.data) {
                    $.each(response.data, function (field, value) {
                        var $control = $form.find('[name=' + regexEscape(field) + ']');
                        response.success && $control.addClass('is-valid');
                        $control.tooltip('destroy');
                        $control.not('input[type=file], input[type=checkbox], input[type=radio]').val(value);
                        if ($control.prop('tagName') == 'SELECT') {
                            $control.find('option').each(function () {
                                var $option = $(this);
                                $option.prop('selected', $option.val() == value);
                            });
                        }
                    });
                }
                if (response.error) {
                    $.each(response.error.fields, function (field, message) {
                        var $field = $form.find('[name=' + regexEscape(field) + ']');
                        var $label = $field.parent().find('label').first();
                        $field.parents('.form-group').first().addClass('has-error');
                        $field.removeClass('is-valid');
                        $field.addClass('has-error');
                        $field.tooltip({
                            animation: false,
                            title: message,
                            trigger: 'manual',
                            placement: 'top',
                            template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
                        }).tooltip('show');
                    });
                }
                setTimeout(function () {
                    $submits.prop("disabled", false);
                    $form.off("submit.prevent");
                }, 250);
                callback && callback(!!response.success, response);
            }
        };
        $form.on("submit.prevent", function (event) {
            event.preventDefault();
        });
        $.ajax(opts);
    };

    $.fn.validate = validate;

})(jQuery);